import { Button } from "@innovationnorway/lighthouse-components";
import cn from "classnames";
import React from "react";
import { UserTask } from "../../../main/models/user-task";
import { sendSiteimproveEvent } from "../../../utils/sendSiteimproveEvent";
import { useLayout } from "../../hooks/useLayout";
import NotificationItem from "./notificationItem/notificationItem";
import "./notificationList.scss";

interface NotificationListProps {
  tasks?: UserTask[];
  onClose?: () => void;
  hideProjectInfo?: boolean;
}

const NotificationList = ({ tasks, onClose, hideProjectInfo }: NotificationListProps) => {
  const { translations } = useLayout();

  return (
    <>
      <div className={cn("notification-list", { "notification-list--expanded": !hideProjectInfo })}>
        {tasks?.map((task) => (
          <NotificationItem key={task.id} task={task} hideProjectInfo={hideProjectInfo} />
        ))}
      </div>
      {onClose && (
        <div aria-live="polite" className="add-profile-succeeded__button">
          <Button
            type="submit"
            variant="secondary"
            onClick={() => {
              sendSiteimproveEvent(`MyPage-openSummaryBeta`, "SummaryClosed", "Summary closed");
              onClose();
            }}
            onKeyUp={(e) => {
              e.stopPropagation();
              if (e.code === "Enter") {
                sendSiteimproveEvent(`MyPage-openSummaryBeta`, "SummaryClosed", "Summary closed");
                onClose();
              }
            }}
          >
            {translations.close}
          </Button>
        </div>
      )}
    </>
  );
};

export default NotificationList;
